import { z } from 'zod';

/** UserCreate — POST /api/eraf/users */
export const userCreateSchema = z
  .object({
    // R8-C-002: .trim() transform prevents WAF 400 from leading/trailing spaces
    email: z
      .string()
      .min(1, '이메일을 입력해주세요')
      .transform((s) => s.trim())
      .pipe(
        z
          .string()
          .email('올바른 이메일 형식을 입력해주세요')
          .max(255, '이메일은 255자 이하여야 합니다')
      ),
    // R8-C-002: max(100) already present — confirmed correct (BE @Size(max=100))
    displayName: z
      .string()
      .min(1, '이름을 입력해주세요')
      .max(100, '이름은 100자 이하여야 합니다'),
    role: z
      .string()
      .min(1, '역할을 선택해주세요'),
    generateTemporaryPassword: z.boolean(),
    initialPassword: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.generateTemporaryPassword) {
      if (!data.initialPassword || data.initialPassword.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: '초기 비밀번호를 입력해주세요',
          path: ['initialPassword'],
        });
      } else if (data.initialPassword.length < 10) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: '비밀번호는 10자 이상이어야 합니다',
          path: ['initialPassword'],
        });
      } else if (data.initialPassword.length > 64) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: '비밀번호는 64자 이하여야 합니다',
          path: ['initialPassword'],
        });
      }
    }
  });

export type UserCreateFormValues = z.infer<typeof userCreateSchema>;

/** UserUpdate — PATCH /api/eraf/users/{id} */
export const userUpdateSchema = z.object({
  displayName: z
    .string()
    .min(1, '이름을 입력해주세요')
    .max(100, '이름은 100자 이하여야 합니다')
    .optional(),
  enabled: z.boolean().optional(),
});

export type UserUpdateFormValues = z.infer<typeof userUpdateSchema>;

/** UserRoleChange — PATCH /api/eraf/users/{id}/role */
export const userRoleChangeSchema = z.object({
  role: z
    .string()
    .min(1, '역할을 선택해주세요'),
});

export type UserRoleChangeFormValues = z.infer<typeof userRoleChangeSchema>;

/** 사용 가능한 역할 옵션 */
export const ROLE_OPTIONS = [
  { value: 'ROLE_ADMIN', label: '관리자' },
  { value: 'ROLE_MANAGER', label: '업무 관리자' },
  { value: 'ROLE_USER', label: '일반 사용자' },
  { value: 'ROLE_GUEST', label: '게스트' },
] as const;
